import React from 'react';
/* eslint-disable */
type PillLabelProps = {
  color: string;
  label: string;
  label_size?: 'text-xs' | 'text-md' | 'text-lg';
  text_color?: string;
};

const PillLabel: React.FC<PillLabelProps> = props => {
  return (
    <span
      className={`px-2 inline-flex ${
        props.label_size ? props.label_size + ' py-0.5' : 'text-xs'
      } leading-5 font-semibold rounded-full ${props.color} ${
        props.text_color ?? 'text-on-primary'
      }`}
    >
      {props.label}
    </span>
  );
};

export default PillLabel;
